import React, { Component } from "react";
import FamilyTree from "@balkangraph/familytree.js";
import "../css/mytree.css";
import { Avatar, Box, Card, CardContent, Drawer, Typography, Button, TextField, Divider } from "@mui/material";
import { connect } from 'react-redux';
import { authApi } from "../../api/api";
import { logout } from "../../features/auth/AuthSlice";
import Toastmessage from "../../components/Toast";
import { Navigate, useLocation } from "react-router-dom";
import Grid from '@mui/material/Grid2';

class Tree extends Component {
  constructor(props) {
    super(props);
    this.divRef = React.createRef();
    this.state = {
      nodes: [],
      isDrawerOpen: false,
      memberId: null,
      user: {
        name: "",
        gender: "",
        dob: "",
        dod: "-",
        relationship: "",
      },
      assets: [],
      totalValue: "",
      globletotalValue: "",
      totalPercentage: "",
      notes: "",
      notesError: false,
    };
  }

  componentDidMount() {
    this.fetchRoleDetails();
    this.setState({ isDrawerOpen: false });
  }

  fetchAssetDetails = async (nodeId) => {
    const { token, userID, dispatch } = this.props;
    const input_token = nodeId + 'ASSIGN_ESTATE';
    const apiUrl = 'assets_with_total_value';
    const dataInput = {
      member_id: nodeId,
      login_user_id: userID
    };

    try {
      const data = await authApi(input_token, dataInput, apiUrl, token);
      if (data && data.success) {
        const assetData = JSON.parse(data?.data?.saved_estate_asset_value?.distributed_property_detail || '{}');
        const categoryMap = {
          "1": "Real Estate",
          "2": "Vehicles",
          "3": "Bank Accounts",
          "4": "Insurance Policies",
          "5": "Other Assets"
        };

        const assets = Object.entries(assetData).map(([categoryId, items]) => ({
          category: categoryMap[categoryId],
          items: items
            .filter(item => item.isChecked) // Filter to include only items where isChecked is true
            .map(item => ({
              property: item.propertyAddress || item.yearMakeModel || item.institutionName || item.description,
              value: `$${parseFloat(item.value || 0).toLocaleString()}`,
              calculatedValue: `$${parseFloat(item.calculatedValue || 0).toLocaleString()}`,
              percentage: `${item.calculatedPercentage || 0}%`
            }))
        }));


        this.setState({
          assets: assets,
          user: {
            ...this.state.user,
            name: data?.data?.family_member_detail?.name,
            gender: data?.data?.family_member_detail?.gender,
            dob: data?.data?.family_member_detail?.bdate,
            dod: data?.data?.family_member_detail?.ddate || "-",
            relationship: data?.data?.family_member_detail?.relationship || "-",
          },
          totalValue: `$${data?.data?.saved_estate_asset_value?.total_assigned_asset_value}` || "$0.00",
          globletotalValue: `$${data?.data?.estate_asset_value?.total_global_estate_value}` || "$0.00",
          totalPercentage: `${data?.data?.saved_estate_asset_value?.total_assigned_assets_percent} %` || "0%",
          notes: data?.data?.saved_estate_asset_value?.additional_notes
        });

      } else if (data && data.message === 'Token has expired') {
        dispatch(logout());
        localStorage.removeItem('token');
        await Toastmessage('Session expired. Redirecting to login...', false);
        Navigate('/login');
      } else {
        await Toastmessage(data?.message || 'An error occurred', false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      if (error.response && error.response.status === 401) {
        dispatch(logout());
        localStorage.removeItem('token');
        await Toastmessage('Session expired. Redirecting to login...', false);
        Navigate('/login');
      } else {
        await Toastmessage('Something went wrong', false);
      }
    }
  };

  AddNotes = async (nodeId) => {
    const { token, userID, dispatch } = this.props;
    const input_token = nodeId + 'ADD_NOTES';
    const apiUrl = 'family_tree_save_assets_notes';
    const dataInput = {
      family_member_id: nodeId,
      login_user_id: userID,
      additional_notes: this.state.notes
    };

    try {
      const data = await authApi(input_token, dataInput, apiUrl, token);
      if (data && data.success) {
        this.setState({ isDrawerOpen: false });
        await Toastmessage(data.message, true);
        this.fetchRoleDetails()
      } else if (data && data.message === 'Token has expired') {
        dispatch(logout());
        localStorage.removeItem('token');
        await Toastmessage('Session expired. Redirecting to login...', false);
        Navigate('/login');
      } else {
        await Toastmessage(data?.message || 'An error occurred', false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      if (error.response && error.response.status === 401) {
        dispatch(logout());
        localStorage.removeItem('token');
        await Toastmessage('Session expired. Redirecting to login...', false);
        Navigate('/login');
      } else {
        await Toastmessage('Something went wrong', false);
      }
    }
  };

  fetchRoleDetails = async () => {
    const { token, userID, treeId, dispatch } = this.props;
    const input_token = 'FAMILY_MEMBER_LIST';
    const apiUrl = 'list_of_family_members';

    const dataInput = {
      family_tree_id: treeId,
      login_user_id: userID
    };

    try {
      const data = await authApi(input_token, dataInput, apiUrl, token);

      if (data && data.success) {
        const updatedData = data?.fatherMembers.map(item => {
          const tags = Array.isArray(item.tags) ? item.tags : [];
          const newTags = new Set(tags);
          const isDivorced = Array.isArray(item.divorced) && item.divorced.some(value => value !== 0);
          if (isDivorced) newTags.add('divorced');
          return {
            ...item,
            gender: item.gender.toLowerCase(),
            name: item.name.length > 30 ? item.name.substring(0, 35) + '...' : item.name,
            img: item.img || '/user.png',
            icon7: item?.is_deceased === 1 ? '/dessesed.png' : null,
            divorced1: isDivorced ? 'Divorced' : null,
            tags: item?.is_deceased === 1 ? [...new Set([...tags, 'deceased'])] : tags,
            icon1: item?.asset_icons[0] ? item?.asset_icons[0] : null,
            icon2: item?.asset_icons[1] ? item?.asset_icons[1] : null,
            icon3: item?.asset_icons[2] ? item?.asset_icons[2] : null,
            icon4: item?.asset_icons[3] ? item?.asset_icons[3] : null,
            icon5: item?.asset_icons[4] ? item?.asset_icons[4] : null,
            icon6: item?.asset_icons[5] ? item?.asset_icons[5] : null
          };
        });
        this.setState({ nodes: updatedData }, this.initializeFamilyTree);

      } else if (data && data.message === 'Token has expired') {
        dispatch(logout());
        localStorage.removeItem('token');
        await Toastmessage('Session expired. Redirecting to login...', false);
        Navigate('/login');
      } else if (data === undefined) {
        console.error('No data received');
      }
    } catch (error) {
      console.error('Error fetching family data:', error);
    }
  };


  initializeFamilyTree = () => {
    FamilyTree.templates.base.defs = `<g transform="matrix(0.05,0,0,0.05,-12,-9)" id="heart">
        <path fill="#aeaeae" d="M438.482,58.61c-24.7-26.549-59.311-41.655-95.573-41.711c-36.291,0.042-70.938,15.14-95.676,41.694l-8.431,8.909  l-8.431-8.909C181.284,5.762,98.663,2.728,45.832,51.815c-2.341,2.176-4.602,4.436-6.778,6.778 c-52.072,56.166-52.072,142.968,0,199.134l187.358,197.581c6.482,6.843,17.284,7.136,24.127,0.654 c0.224-0.212,0.442-0.43,0.654-0.654l187.29-197.581C490.551,201.567,490.551,114.77,438.482,58.61z"/>
        </g>
     <g transform="matrix(1,0,0,1,0,0)" id="dot"></g>
      <g id="base_node_menu" style="cursor:pointer;">
          <rect x="0" y="0" fill="transparent" width="22" height="18"></rect>
          <circle cx="4" cy="11" r="2" fill="#b1b9be"></circle>
          <circle cx="11" cy="11" r="2" fill="#b1b9be"></circle>
          <circle cx="18" cy="11" r="2" fill="#b1b9be"></circle>
      </g>
      <g style="cursor: pointer;" id="base_tree_menu">
          <rect x="0" y="0" width="25" height="25" fill="transparent"></rect>
          ${FamilyTree.icon.addUser(25, 25, "#fff", 0, 0)}
      </g>
      <g style="cursor: pointer;" id="base_tree_menu_close">
          <circle cx="12.5" cy="12.5" r="12" fill="#F57C00"></circle>
          ${FamilyTree.icon.close(25, 25, "#fff", 0, 0)}
      </g>
      <g id="base_up">
          <circle cx="115" cy="30" r="15" fill="#fff" stroke="#b1b9be" stroke-width="1"></circle>
          ${FamilyTree.icon.ft(20, 80, "#b1b9be", 105, -10)}
      </g>
      <clipPath id="base_img_0">
        <circle id="base_img_0_stroke" cx="45" cy="62" r="35"/>
      </clipPath>
      <clipPath id="base_img_1">
        <circle id="base_img_1_stroke" cx="100" cy="62" r="35"/>
      </clipPath>
      `;

    FamilyTree.templates.main = Object.assign({}, FamilyTree.templates.base);
    FamilyTree.templates.main.defs = `<style>
                                        .{randId} .bft-edit-form-header, .{randId} .bft-img-button{
                                            background-color: #aeaeae;
                                        }
                                        .{randId}.male .bft-edit-form-header, .{randId}.male .bft-img-button{
                                            background-color: #6bb4df;
                                        }
                                        .{randId}.male div.bft-img-button:hover{
                                            background-color: #00000;
                                        }
                                        .{randId}.female .bft-edit-form-header, .{randId}.female .bft-img-button{
                                            background-color: #cb4aaf;
                                        }
                                        .{randId}.female div.bft-img-button:hover{
                                            background-color: #6bb4df;
                                        }
    </style>`;
    FamilyTree.templates.main.node =
      '<rect x="0" y="0" height="{h}" width="{w}" fill="#ffffff" stroke-width="3" stroke="#ccc" rx="5" ry="5"></rect>' +
      '<rect x="0" y="0" height="18" width="{w}" fill="#b1b9be" stroke-width="1" stroke="#b1b9be" rx="5" ry="5"></rect>' +
      '<line x1="0" y1="20" x2="250" y2="20" stroke-width="5" stroke="#b1b9be"></line>';

    FamilyTree.templates.main.field_0 =
      "<text " +
      FamilyTree.attr.width +
      ' ="250" style="font-size: 20px;" font-variant="all-small-caps" fill="white" x="125" y="16" text-anchor="middle">{val}</text>';
    FamilyTree.templates.main.field_1 =
      "<text " +
      FamilyTree.attr.width +
      ' ="170" data-text-overflow="multiline" style="font-size: 15px;" fill="black" x="90" y="50" text-anchor="start">{val}</text>';
    FamilyTree.templates.main.field_2 =
      "<text " +
      FamilyTree.attr.width +
      ' ="160" style="font-size: 18px;" fill="black" x="90" y="100" text-anchor="start">{val}</text>';
    FamilyTree.templates.main.img_0 =
      `<image preserveAspectRatio="xMidYMid slice" clip-path="url(#base_img_0)" xlink:href="{val}" x="15" y="26" width="60" height="60"></image>`;
    FamilyTree.templates.main.icon = `<g id="flex" transform="translate(50, 90)">
    <image 
      xlink:href={val}
      x="-30" 
      y="3" 
      width="20" 
      height="20" 
      preserveAspectRatio="xMidYMid slice">
    </image>
  </g>`;
    FamilyTree.templates.main.icon1 = `<g id="flex" transform="translate(50, 90)">
  <image 
    xlink:href={val}
     x="0" 
      y="3" 
      width="20" 
      height="20"
    preserveAspectRatio="xMidYMid slice">
  </image>
</g>`;

    FamilyTree.templates.main.icon2 = `<g id="flex" transform="translate(50, 90)">
<image 
  xlink:href={val}
   x="30" 
    y="3" 
    width="20" 
    height="20"
  preserveAspectRatio="xMidYMid slice">
</image>
</g>`;
    FamilyTree.templates.main.icon3 = `<g id="flex" transform="translate(50, 90)">
<image 
  xlink:href={val}
   x="60" 
    y="3" 
    width="20" 
    height="20"
  preserveAspectRatio="xMidYMid slice">
</image>
</g>`;
    FamilyTree.templates.main.icon4 = `<g id="flex" transform="translate(50, 90)">
<image 
  xlink:href={val}
   x="90" 
    y="3" 
    width="20" 
    height="20"
  preserveAspectRatio="xMidYMid slice">
</image>
</g>`;
    FamilyTree.templates.main.icon5 = `<g id="flex" transform="translate(50, 90)">
<image 
  xlink:href={val}
   x="120" 
    y="3" 
    width="20" 
    height="20"
  preserveAspectRatio="xMidYMid slice">
</image>
</g>`;
    FamilyTree.templates.main.icon7 = `
<image 
  xlink:href="{val}"
  x="210" 
  y="80" 
  width="30" 
  height="30" 
  preserveAspectRatio="xMidYMid slice">
</image>
`;


    FamilyTree.templates.main_male = Object.assign(
      {},
      FamilyTree.templates.main
    );
    FamilyTree.templates.main_male.node =
      '<rect x="0" y="0" height="{h}" width="{w}" fill="#ffffff" stroke-width="3" stroke="#6bb4df" rx="5" ry="5"></rect>' +
      '<rect x="0" y="0" height="18" width="{w}" fill="#6bb4df" stroke-width="1" stroke="#6bb4df" rx="5" ry="5"></rect>' +
      '<line x1="0" y1="20" x2="250" y2="20" stroke-width="5" stroke="#6bb4df"></line>';
    FamilyTree.templates.main_female = Object.assign(
      {},
      FamilyTree.templates.main_male
    );
    FamilyTree.templates.main_female.node =
      '<rect x="0" y="0" height="{h}" width="{w}" fill="#ffffff" stroke-width="3" stroke="#cb4aaf" rx="5" ry="5"></rect>' +
      '<rect x="0" y="0" height="18" width="{w}" fill="#cb4aaf" stroke-width="1" stroke="#cb4aaf" rx="5" ry="5"></rect>' +
      '<line x1="0" y1="20" x2="250" y2="20" stroke-width="5" stroke="#cb4aaf"></line>'
      ;

    FamilyTree.templates.deceased = Object.assign(
      {},
      FamilyTree.templates.tommy
    );
    FamilyTree.templates.deceased.node = `
    <rect x="0" y="0" height="{h}" width="{w}" fill="#ffffff" stroke-width="3" stroke="#aeaeae" rx="5" ry="5"></rect>
    <rect x="0" y="0" height="18" width="{w}" fill="#aeaeae" stroke-width="1" stroke="#aeaeae" rx="5" ry="5"></rect>
    <line x1="0" y1="20" x2="250" y2="20" stroke-width="5" stroke="#aeaeae"></line>
  `;

    FamilyTree.templates.deceased.field_0 = `
    <text ${FamilyTree.attr.width}="250" style="font-size: 20px;" font-variant="all-small-caps" fill="white" x="125" y="16" text-anchor="middle">{val}</text>
  `;

    FamilyTree.templates.main.field_0 =
      "<text " +
      FamilyTree.attr.width +
      ' ="250" style="font-size: 20px;" font-variant="all-small-caps" fill="white" x="125" y="16" text-anchor="middle">{val}</text>';

    //   FamilyTree.templates.deceased.field_1 = `
    //   <text style="font-size: 18px;" fill="#000000" x="140" y="60" text-anchor="middle">{val}</text>
    // `;
    FamilyTree.templates.deceased.field_1 =
      "<text " +
      FamilyTree.attr.width +
      '="170" data-text-overflow="multiline" style="font-size: 15px;" fill="black" x="90" y="50" text-anchor="start">{val}</text>';

     

    //   FamilyTree.templates.deceased.img_0 = `
    // <use xlink:href="#base_img_0_stroke" /> 
    // <circle id="base_img_0_stroke" fill="#b1b9be" cx="45" cy="62" r="37"/>
    // <image preserveAspectRatio="xMidYMid slice" clip-path="url(#base_img_0)" xlink:href="{val}" x="10" y="26" width="72" height="72"></image>`;
    FamilyTree.templates.deceased.img_0 =
      `<image preserveAspectRatio="xMidYMid slice" clip-path="url(#base_img_0)" xlink:href="{val}" x="15" y="26" width="60" height="60"></image>`;

    FamilyTree.templates.deceased.icon = `<g id="flex" transform="translate(50, 90)">
      <image 
        xlink:href={val}
        x="-30" 
        y="3" 
        width="20" 
        height="20" 
        preserveAspectRatio="xMidYMid slice">
      </image>
    </g>`;
    FamilyTree.templates.deceased.icon1 = `<g id="flex" transform="translate(50, 90)">
    <image 
      xlink:href={val}
       x="0" 
        y="3" 
        width="20" 
        height="20"
      preserveAspectRatio="xMidYMid slice">
    </image>
  </g>`;

    FamilyTree.templates.deceased.icon2 = `<g id="flex" transform="translate(50, 90)">
  <image 
    xlink:href={val}
     x="30" 
      y="3" 
      width="20" 
      height="20"
    preserveAspectRatio="xMidYMid slice">
  </image>
  </g>`;
    FamilyTree.templates.deceased.icon3 = `<g id="flex" transform="translate(50, 90)">
  <image 
    xlink:href={val}
     x="60" 
      y="3" 
      width="20" 
      height="20"
    preserveAspectRatio="xMidYMid slice">
  </image>
  </g>`;
    FamilyTree.templates.deceased.icon4 = `<g id="flex" transform="translate(50, 90)">
  <image 
    xlink:href={val}
     x="90" 
      y="3" 
      width="20" 
      height="20"
    preserveAspectRatio="xMidYMid slice">
  </image>
  </g>`;
    FamilyTree.templates.deceased.icon5 = `<g id="flex" transform="translate(50, 90)">
  <image 
    xlink:href={val}
     x="120" 
      y="3" 
      width="20" 
      height="20"
    preserveAspectRatio="xMidYMid slice">
  </image>
  </g>`;
    FamilyTree.templates.deceased.icon7 = `
  <image 
    xlink:href="{val}"
    x="210" 
    y="80" 
    width="30" 
    height="30" 
    preserveAspectRatio="xMidYMid slice">
  </image>
  `;


    FamilyTree.templates.trust = Object.assign(
      {},
      FamilyTree.templates.tommy
    );
    FamilyTree.templates.trust.node = `<circle cx="100" cy="100" r="100" fill="white" stroke-width="3" stroke="#cb4aaf"></circle>`;
    FamilyTree.templates.trust.size = [200, 200];
    FamilyTree.templates.trust.field_1 = `
      <text width="160" data-text-overflow="multiline" style="font-size: 17px; font-variant: all-small-caps; font-weight: bold; fill: black;" x="100" y="170" text-anchor="middle">{val}</text>
    `;
    FamilyTree.templates.trust.field_0 = `
      <text width="190" style="font-size: 14px; fill: black; " x="100" y="150" text-anchor="middle">{val}</text>
    `;
    FamilyTree.templates.trust.img_0 = `
    <use xlink:href="#base_img_1_stroke"/> 
           <circle id="base_img_1_stroke" fill="#cb4aaf" cx="100" cy="62" r="37"/>
          <image preserveAspectRatio="xMidYMid slice" clip-path="url(#base_img_1)" xlink:href="{val}" x="65" y="26" width="72" height="72"></image>
    `;

    FamilyTree.templates.trust.icon = `<g id="flex" transform="translate(50, 90)">
    <image 
      xlink:href={val}
      x="-30" 
      y="15" 
      width="20" 
      height="20" 
      preserveAspectRatio="xMidYMid slice">
    </image>
  </g>`;
    FamilyTree.templates.trust.icon1 = `<g id="flex" transform="translate(50, 90)">
  <image 
    xlink:href={val}
     x="0" 
      y="15" 
      width="20" 
      height="20"
    preserveAspectRatio="xMidYMid slice">
  </image>
</g>`;

    FamilyTree.templates.trust.icon2 = `<g id="flex" transform="translate(50, 90)">
<image 
  xlink:href={val}
   x="30" 
    y="15" 
    width="20" 
    height="20"
  preserveAspectRatio="xMidYMid slice">
</image>
</g>`;
    FamilyTree.templates.trust.icon3 = `<g id="flex" transform="translate(50, 90)">
<image 
  xlink:href={val}
   x="60" 
    y="15" 
    width="20" 
    height="20"
  preserveAspectRatio="xMidYMid slice">
</image>
</g>`;
    FamilyTree.templates.trust.icon4 = `<g id="flex" transform="translate(50, 90)">
<image 
  xlink:href={val}
   x="90" 
    y="15" 
    width="20" 
    height="20"
  preserveAspectRatio="xMidYMid slice">
</image>
</g>`;
    FamilyTree.templates.trust.icon5 = `<g id="flex" transform="translate(50, 90)">
<image 
  xlink:href={val}
   x="120" 
    y="15" 
    width="20" 
    height="20"
  preserveAspectRatio="xMidYMid slice">
</image>
</g>`;



    FamilyTree.templates.adopted_male = Object.assign({}, FamilyTree.templates.main);
    FamilyTree.templates.adopted_male.node =
      '<rect x="0" y="0" height="{h}" width="{w}" fill="#ffffff" stroke-width="3" stroke="#33ff66" rx="5" ry="5"></rect>' +
      '<rect x="0" y="0" height="18" width="{w}" fill="#33ff66" stroke-width="1" stroke="#33ff66" rx="5" ry="5"></rect>' +
      '<line x1="0" y1="20" x2="250" y2="20" stroke-width="5" stroke="#33ff66"></line>';
    FamilyTree.templates.adopted_male.icon = `<g id="flex" transform="translate(50, 90)">
      <image 
        xlink:href={val}
        x="-30" 
        y="3" 
        width="20" 
        height="20" 
        preserveAspectRatio="xMidYMid slice">
      </image>
    </g>`;
    FamilyTree.templates.adopted_male.icon1 = `<g id="flex" transform="translate(50, 90)">
    <image 
      xlink:href={val}
       x="0" 
        y="3" 
        width="20" 
        height="20"
      preserveAspectRatio="xMidYMid slice">
    </image>
  </g>`;

    FamilyTree.templates.adopted_male.icon2 = `<g id="flex" transform="translate(50, 90)">
  <image 
    xlink:href={val}
     x="30" 
      y="3" 
      width="20" 
      height="20"
    preserveAspectRatio="xMidYMid slice">
  </image>
  </g>`;
    FamilyTree.templates.adopted_male.icon3 = `<g id="flex" transform="translate(50, 90)">
  <image 
    xlink:href={val}
     x="60" 
      y="3" 
      width="20" 
      height="20"
    preserveAspectRatio="xMidYMid slice">
  </image>
  </g>`;
    FamilyTree.templates.adopted_male.icon4 = `<g id="flex" transform="translate(50, 90)">
  <image 
    xlink:href={val}
     x="90" 
      y="3" 
      width="20" 
      height="20"
    preserveAspectRatio="xMidYMid slice">
  </image>
  </g>`;
    FamilyTree.templates.adopted_male.icon5 = `<g id="flex" transform="translate(50, 90)">
  <image 
    xlink:href={val}
     x="120" 
      y="3" 
      width="20" 
      height="20"
    preserveAspectRatio="xMidYMid slice">
  </image>
  </g>`;
    FamilyTree.templates.adopted_male.icon7 = `
  <image 
    xlink:href="{val}"
    x="210" 
    y="80" 
    width="30" 
    height="30" 
    preserveAspectRatio="xMidYMid slice">
  </image>
  `;

    FamilyTree.templates.adopted_female = Object.assign({}, FamilyTree.templates.main);
    FamilyTree.templates.adopted_female.node =
      '<rect x="0" y="0" height="{h}" width="{w}" fill="#ffffff" stroke-width="3" stroke="#f2e30c" rx="5" ry="5"></rect>' +
      '<rect x="0" y="0" height="18" width="{w}" fill="#f2e30c" stroke-width="1" stroke="#f2e30c" rx="5" ry="5"></rect>' +
      '<line x1="0" y1="20" x2="250" y2="20" stroke-width="5" stroke="#f2e30c"></line>';

    // FamilyTree.templates.adopted_female = Object.assign(
    //   {},
    //   FamilyTree.templates.tommy
    // );
    // FamilyTree.templates.adopted_female.node = `<rect x="0" y="0" height="{h}" width="{w}" fill="#ffffff" stroke-width="3" stroke="#f2e30c" rx="5" ry="5"></rect>' +
    //     '<rect x="0" y="0" height="18" width="{w}" fill="#f2e30c" stroke-width="1" stroke="#f2e30c" rx="5" ry="5"></rect>' +
    //     '<line x1="0" y1="20" x2="250" y2="20" stroke-width="5" stroke="#f2e30c"></line>
    //    `;
    //    FamilyTree.templates.adopted_female.field_0 = `
    //    <text width="250" style="font-size: 20px;" font-variant="all-small-caps" fill="white" x="125" y="16" text-anchor="middle">{val}</text>
    //  `;
    // FamilyTree.templates.adopted_female.field_1 = `<text style="font-size: 18px; white-space: normal;" fill="#000000" x="60" y="60" textLength="200" lengthAdjust="spacingAndGlyphs">{val}</text>`;
    // FamilyTree.templates.adopted_female.img_0 =
    //   `<use xlink:href="#base_img_0_stroke" /> 
    //      <circle id="base_img_0_stroke" fill="#b1b9be" cx="45" cy="62" r="37"/>
    //      <image preserveAspectRatio="xMidYMid slice" clip-path="url(#base_img_0)" xlink:href="{val}" x="10" y="26" width="72" height="72"></image>`;

    this.family = new FamilyTree(this.divRef.current, {

      nodes: this.state.nodes,

      align: FamilyTree.align.center,
      template: "main",
      scaleInitial: 0.8,
      nodeBinding: {
        field_0: "relationship",
        field_1: "name",
        field_2: "divorced1",
        img_0: "img",
        icon: "icon1",
        icon1: "icon2",
        icon2: "icon3",
        icon3: "icon4",
        icon4: "icon5",
        icon5: "icon6",
        icon7: "icon7",

      },
      editForm: false,
      menu: {
        pdf: { text: "Export PDF" },
        png: { text: "Export PNG" },
        svg: { text: "Export SVG" },
        csv: { text: "Export CSV" },
        json: { text: "Export JSON" },
      },
      tags: {
        deceased: { template: "deceased" },
        adopted_female: { template: "adopted_female" },
        adopted_male: { template: "adopted_male" },
        trust: { template: "trust" },
      },

      nodeMouseClick: FamilyTree.action.none,
    });

    this.family.onNodeClick((args) => {
      if (args.node && args.node.id) {
        this.setState({ isDrawerOpen: true });
        this.fetchAssetDetails(args.node.id);
        this.setState({ memberId: args.node.id });
      } else {
        console.error("Node ID is undefined");
      }
      return false;
    });

    let family = this.family;
    this.family.on("render-link", function (sender, args) {
      var cnodeData = family.get(args.cnode.id);
      var nodeData = family.get(args.node.id);

      if (
        Array.isArray(cnodeData.divorced) &&
        Array.isArray(nodeData.divorced) &&
        cnodeData.divorced.includes(args.node.id) &&
        nodeData.divorced.includes(args.cnode.id)
      ) {
        if (typeof args.html === 'string') {
          args.html = args.html.replace(
            "path",
            "path stroke-dasharray='3, 1'  stroke-width=5px stroke=#ed0c0c"
          );
        }
      }

      if (
        (Array.isArray(cnodeData.tags) && cnodeData.tags.includes("trust")) ||
        (Array.isArray(nodeData.tags) && nodeData.tags.includes("trust"))
      ) {
        if (typeof args.html === 'string') {
          args.html = args.html.replace(
            "path",
            "path stroke-dasharray='4, 2' stroke-width=2px stroke=blue"
          );
        }
      }
    });
  };

  toggleDrawer = (open) => {
    this.setState({ isDrawerOpen: false });
  };

  handleNotesChange = (event) => {
    this.setState({ notes: event.target.value, notesError: false });
  };

  handleSubmit = async () => {
    const { notes } = this.state;
    if (!notes.trim()) {
      this.setState({ notesError: true });
      return;
    }
    this.AddNotes(this.state.memberId);
  };



  generateMultipleImages(images) {
    if (images && images.length > 0) {
      // Return an array of SVG image tags to be rendered by FamilyTree
      return images.map((image, index) => ({
        tag: 'image',
        attributes: {
          'xlink:href': image,
          x: 65 + index * 80,
          y: 26,
          width: 72,
          height: 72,
          preserveAspectRatio: 'xMidYMid slice',
        },
      }));
    }
    return null; // Return null if no images are available
  }

  render() {
    const { isDrawerOpen, user, assets, totalValue, totalPercentage, notes, notesError, globletotalValue } = this.state;
    return (
      <>
        <Box
          ref={this.divRef}
          sx={{
            width: "100%",
            height: "100vh",
            overflow: "hidden",
            margin: 0,
            padding: 0,
          }}
        />

        <Drawer anchor="right" open={isDrawerOpen} sx={{
          '& .MuiDrawer-paper': {
            maxWidth: '600px',
            width: '100%',
          },
        }} onClose={() => this.toggleDrawer(false)}>
          <Box sx={{ p: 2 }}>
            <Card sx={{ mb: 0, pb: 0, boxShadow: 'none', '& .MuiCardContent-root': { paddingBottom: '10px' } }} >
              <CardContent sx={{ p: 0, border: "none" }} style={{ padding: '0px !important' }}>
                <Grid p={0} container spacing={1}>
                  <Grid size={12} bgcolor={'#F3F4FC'} p={1}>
                    <Typography fontSize={18} fontWeight="bold">
                      {user.name.toUpperCase()}
                    </Typography>
                  </Grid>
                  <Grid size={3}>
                    <Typography variant="subtitle1" fontSize={12} color="#838893">Gender</Typography>
                    <Typography color="primary">{user.gender}</Typography>
                  </Grid>
                  <Grid size={2}>
                    <Typography variant="subtitle1" fontSize={12} color="#838893">DOB</Typography>
                    <Typography color="primary">{user.dob}</Typography>
                  </Grid>
                  <Grid size={2}>
                    <Typography variant="subtitle1" fontSize={12} color="#838893">DOD</Typography>
                    <Typography color="text.secondary">{user.dod}</Typography>
                  </Grid>
                  <Grid size={4}>
                    <Typography variant="subtitle1" fontSize={12} color="#838893">Relationship</Typography>
                    <Typography color="text.secondary">{user.relationship}</Typography>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
            {assets?.length > 0 && (
              <Box>
                <Typography variant="h6" fontWeight="bold" gutterBottom>
                  Assets Details
                </Typography>

                {assets?.map((category, index) => (
                  <React.Fragment key={category.category}>
                    <Box sx={{ mb: 0 }}>
                      <Typography
                        variant="subtitle1"
                        fontWeight="bold"
                        sx={{ display: "flex", alignItems: "center", mb: 0 }}
                      >
                        <Avatar
                          sx={{
                            mr: 1,
                            width: 24,
                            height: 24,
                            bgcolor: "primary.main",
                            fontSize: 12,
                          }}
                        >
                          {index + 1}
                        </Avatar>
                        {category.category}
                      </Typography>

                      <Grid container spacing={0}>
                        {category.items.map((item, idx) => (
                          <Grid
                            container
                            key={idx}
                            sx={{
                              border: "none",
                              borderRadius: 1,
                              p: 1,
                              mb: 0,
                            }}
                            size={12}
                          >
                            <Grid size={3}>
                              <Typography variant="body2" fontSize={12} color="#838893">
                                Property
                              </Typography>
                              <Typography fontSize={13} color="#252B42" mt={1}>{item.property}</Typography>
                            </Grid>
                            <Grid size={3}>
                              <Typography variant="body2" fontSize={12} color="#838893">
                                Property Value
                              </Typography>
                              <Typography fontSize={13} color="#252B42" mt={1}>{item.value}</Typography>
                            </Grid>
                            <Grid size={3}>
                              <Typography variant="body2" fontSize={12} color="#838893">
                                Assigned Value
                              </Typography>
                              <Typography fontSize={13} color="#252B42" mt={1}>{item.calculatedValue}</Typography>
                            </Grid>
                            <Grid size={3}>
                              <Typography variant="body2" fontSize={12} color="#838893">
                                Assigned Percentage
                              </Typography >
                              <Typography fontSize={13} color="#252B42" mt={1}>{item.percentage}</Typography>
                            </Grid>
                          </Grid>
                        ))}
                      </Grid>
                    </Box>
                    <Divider sx={{ marginBottom: '10px' }} color="black" />
                  </React.Fragment>
                ))}

                <Card sx={{ mb: 3, boxShadow: 'none' }}>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <Typography>Total Value</Typography>
                      <Typography fontWeight="bold">{parseFloat(globletotalValue.replace('$', '')).toLocaleString('en-US', { style: 'currency', currency: 'USD' })}</Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography>Total Assigned Value</Typography>
                      <Typography fontWeight="bold">{parseFloat(totalValue.replace('$', '')).toLocaleString('en-US', { style: 'currency', currency: 'USD' })}</Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography>Total Assigned Percentage</Typography>
                      <Typography fontWeight="bold">{totalPercentage}</Typography>
                    </Grid>
                  </Grid>
                </Card>
              </Box>
            )}
          </Box>
          <Divider sx={{ marginBottom: '10px' }} color="black" />

          <Box sx={{ width: '100%', p: 2 }}>
            <TextField
              fullWidth
              multiline
              rows={4}
              variant="outlined"
              placeholder="Enter the notes"
              value={notes}
              onChange={this.handleNotesChange}
              error={notesError}
              helperText={notesError ? "Notes cannot be empty" : ""}
            />
            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
              <Button
                variant="outlined"
                color="secondary"
                sx={{ mr: 1 }}
                onClick={() => this.toggleDrawer(false)}
              >
                Cancel
              </Button>
              <Button variant="contained" color="primary" onClick={this.handleSubmit}>
                Submit
              </Button>
            </Box>
          </Box>
        </Drawer>
      </>
    );
  }
};

const mapStateToProps = (state) => ({
  token: state.auth.token,
  userID: state.auth.id,
});

const TreeWrapper = (props) => {
  const location = useLocation();
  const treeId = location?.state?.treeId;

  return <Tree {...props} treeId={treeId} />;
};

export default connect(mapStateToProps)(TreeWrapper);









